module.exports = __webpack_public_path__ + "static/img/zhutuikuan.b3da703.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhutuikuan.png
// module id = XNvE
// module chunks = 18